import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f46c142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-container w-75 mx-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-4" }, "Free Career-Boosting Online Courses (2025)", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-4" }, " Explore our curated collection of free online courses, updated for 2025, to enhance your resume and advance your career. Choose from various categories including programming, data science, and business skills. ", -1))
const _hoisted_4 = { class: "d-flex gap-2 mb-4" }
const _hoisted_5 = { class: "search-box flex-grow-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1))
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-funnel" }, null, -1))
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "card border-0 shadow-sm courses-table" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table table-hover mb-0" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Link", -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "course-details"
}
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "course-title mb-3" }
const _hoisted_22 = { class: "provider mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-building me-2" }, null, -1))
const _hoisted_24 = { class: "description mb-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted mb-2" }, "Description", -1))
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right me-2" }, null, -1))
const _hoisted_28 = { class: "cta-section pt-0 p-4 position-relative" }
const _hoisted_29 = { class: "position-relative z-1" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "cta-heading mb-3" }, "Supercharge Your Job Hunt", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap gap-3 mb-3 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "feature-badge-item" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill" }),
    /*#__PURE__*/_createTextVNode(" Cover Letter Generator ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "feature-badge-item" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightning-fill" }),
    /*#__PURE__*/_createTextVNode(" ATS Resume Optimization ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "feature-badge-item" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up" }),
    /*#__PURE__*/_createTextVNode("Beautiful Application Tracking ")
  ])
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Join thousands of job seekers who've landed their dream jobs faster with JobBuddy ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-rocket-takeoff me-2" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 testimonial-mini" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stars text-warning" }),
  /*#__PURE__*/_createTextVNode(" \"JobBuddy helped me land 3 interviews in my first week!\" - Sarah T. ")
], -1))

import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useHead } from "@unhead/vue";
import Modal from "@/components/Modal.vue";
import coursesData from "@/assets/courses/courses.json";
import { loginWithRedirect } from "../auth/auth0";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoursesView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const courses = ref(coursesData);
const searchQuery = ref("");
const sortField = ref("Technology");
const sortDirection = ref("asc");
const activeCategory = ref("");
const courseDetailsModal = ref();
const ctaModal = ref();
const selectedCourse = ref(null);
const ctaShown = ref(false);

// SEO metadata
useHead({
  title: "Free Online Courses to Boost Your Resume (2025) | JobBuddy",
  meta: [
    {
      name: "description",
      content:
        "Discover free online courses updated for 2025 to enhance your resume. Browse through programming, data science, and business courses from top providers to advance your career.",
    },
    {
      name: "keywords",
      content:
        "free courses, online learning, career development, resume enhancement, programming courses, 2025 courses",
    },
    {
      property: "og:title",
      content: "Free Online Courses to Boost Your Resume (2025)",
    },
    {
      property: "og:description",
      content:
        "Explore our curated collection of free online courses, updated for 2025, to enhance your resume and advance your career.",
    },
  ],
});

// Generate category colors
const categoryColors = new Map();
const pastelColors = [
  "#FFB3BA",
  "#BAFFC9",
  "#BAE1FF",
  "#FFFFBA",
  "#FFB3FF",
  "#B3FFB3",
  "#B3B3FF",
  "#FFE4B3",
  "#B3FFE4",
  "#FFB3E4",
];

const uniqueCategories = computed(() => {
  const categories = new Set(courses.value.map((course) => course.Category));
  return Array.from(categories).sort();
});

const getCategoryColor = (category: string) => {
  if (!categoryColors.has(category)) {
    const colorIndex = categoryColors.size % pastelColors.length;
    categoryColors.set(category, pastelColors[colorIndex]);
  }
  return categoryColors.get(category);
};

// Handle route query parameters
onMounted(() => {
  const categoryQuery = route.query.category as string;
  if (categoryQuery) {
    activeCategory.value = decodeURIComponent(categoryQuery);
  }

  // Add scroll listener for CTA modal
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  // Remove scroll listener
  window.removeEventListener("scroll", handleScroll);
});

const handleScroll = () => {
  // Show CTA modal when user scrolls down 300px and hasn't been shown yet
  if (window.scrollY > 300 && !ctaShown.value) {
    ctaModal.value.show();
    ctaShown.value = true;
  }
};

const signup = () => {
  loginWithRedirect({
    screen: "signup",
    screen_hint: "signup",
    appState: { target: "/dashboard" },
  });
};

const setCategory = (category: string) => {
  activeCategory.value = category;
  if (category) {
    router.push({ query: { ...route.query, category: encodeURIComponent(category) } });
  } else {
    const { category, ...queryWithoutCategory } = route.query;
    router.push({ query: queryWithoutCategory });
  }
};

const filteredCourses = computed(() => {
  return courses.value
    .filter((course) => {
      const matchesSearch =
        searchQuery.value === "" ||
        course.Technology.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        course.Provider.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        course.Category.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        course.Description.toLowerCase().includes(searchQuery.value.toLowerCase());

      const matchesCategory = !activeCategory.value || course.Category === activeCategory.value;

      return matchesSearch && matchesCategory;
    })
    .sort((a, b) => {
      const aValue = a[sortField.value];
      const bValue = b[sortField.value];

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortDirection.value === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return sortDirection.value === "asc" ? (aValue > bValue ? 1 : -1) : bValue > aValue ? 1 : -1;
    });
});

const sortBy = (field: string) => {
  if (sortField.value === field) {
    sortDirection.value = sortDirection.value === "asc" ? "desc" : "asc";
  } else {
    sortField.value = field;
    sortDirection.value = "asc";
  }
};

const getSortIcon = (field: string) => {
  if (sortField.value !== field) return "bi bi-chevron-expand";
  return sortDirection.value === "asc" ? "bi bi-chevron-up" : "bi bi-chevron-down";
};

const showCourseDetails = (course) => {
  selectedCourse.value = course;
  courseDetailsModal.value.show();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search courses...",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event))
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(activeCategory.value || "All Categories"), 1)
          ]),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setCategory('')))
              }, "All Categories")
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueCategories.value, (category) => {
              return (_openBlock(), _createElementBlock("li", { key: category }, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: ($event: any) => (setCategory(category))
                }, _toDisplayString(category), 9, _hoisted_11)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sortable-header",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (sortBy('Technology')))
                }, [
                  _createTextVNode(" Course Title "),
                  _createElementVNode("i", {
                    class: _normalizeClass([getSortIcon('Technology'), "sort-icon"])
                  }, null, 2)
                ]),
                _createElementVNode("th", {
                  class: "sortable-header",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (sortBy('Provider')))
                }, [
                  _createTextVNode(" Provider "),
                  _createElementVNode("i", {
                    class: _normalizeClass([getSortIcon('Provider'), "sort-icon"])
                  }, null, 2)
                ]),
                _createElementVNode("th", {
                  class: "sortable-header",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('Category')))
                }, [
                  _createTextVNode(" Category "),
                  _createElementVNode("i", {
                    class: _normalizeClass([getSortIcon('Category'), "sort-icon"])
                  }, null, 2)
                ]),
                _hoisted_15
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCourses.value, (course) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: course.ID,
                  onClick: ($event: any) => (showCourseDetails(course)),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("td", null, _toDisplayString(course.Technology), 1),
                  _createElementVNode("td", null, _toDisplayString(course.Provider), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: "category-badge text-nowrap",
                      style: _normalizeStyle({ backgroundColor: getCategoryColor(course.Category) })
                    }, _toDisplayString(course.Category), 5)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: course.Link,
                      target: "_blank",
                      class: "btn btn-link"
                    }, [
                      _hoisted_18,
                      _createTextVNode(" View Course ")
                    ], 8, _hoisted_17)
                  ])
                ], 8, _hoisted_16))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Modal, {
      ref_key: "courseDetailsModal",
      ref: courseDetailsModal,
      "hide-header": "",
      "modal-md": ""
    }, {
      body: _withCtx(() => [
        (selectedCourse.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("h4", _hoisted_21, _toDisplayString(selectedCourse.value.Technology), 1),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createTextVNode(" " + _toDisplayString(selectedCourse.value.Provider), 1)
                ]),
                _createElementVNode("span", {
                  class: "category-badge",
                  style: _normalizeStyle({ backgroundColor: getCategoryColor(selectedCourse.value.Category) })
                }, _toDisplayString(selectedCourse.value.Category), 5)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("p", null, _toDisplayString(selectedCourse.value.Description), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("a", {
          href: selectedCourse.value?.Link,
          target: "_blank",
          class: "btn btn-primary"
        }, [
          _hoisted_27,
          _createTextVNode(" View Course on " + _toDisplayString(selectedCourse.value?.Provider), 1)
        ], 8, _hoisted_26)
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      ref_key: "ctaModal",
      ref: ctaModal,
      "modal-md": "",
      "hide-footer": ""
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _hoisted_31,
            _hoisted_32,
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (signup())),
              class: "btn btn-primary btn-lg pulse-animation"
            }, [
              _hoisted_33,
              _createTextVNode("Get Started Free ")
            ]),
            _hoisted_34
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})